// removed by extract-text-webpack-plugin
module.exports = {"list":"src-components-solutions----IndexSolutions-module---list---39VvH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/solutions/IndexSolutions.module.css
// module id = 430
// module chunks = 168707334958949